<template>
    <div v-redirect-if-no-permission:SERVICES>
        <v-dialog lazy :value="!!extraChargesServiceId" @input="extraChargesServiceId = null">
            <v-card>
                <v-card-title primary-title class="title font-weight-bold">
                    Extra Charges
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <DataTable
                            v-if="extraChargesServiceId"
                            :url="api.ACTIONS.SERVICE_EXTRA_CHARGES(extraChargesServiceId)"
                            :enable-edit="false"
                            :fields-extra-add="fieldsExtraAddExtraCharges"
                            :titles="titlesExtraCharges"
                            :fields-hidden-add="['id','created_at','updated_at','deleted_at','service_price_id']"
                            :fields-hidden-main="['service_price_id','updated_at']"
                            :add-rules="rulesExtraCharge"
                            :formatter="formatterExtraCharges"
                            :input-types-add="{to_date: {clearable: true},
                            area_id: {multi :false},
                            apply_area_on: {items: ['PICKUP','PULLDOWN','BOTH'],clearable: true},
                            type : {items: ['CASH','PERCENTAGE' ],clearable: true},
                             }"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
        <DataTable
                v-if="name" :url="api.ACTIONS.SERVICE_PRICES(id)"
                disableSearch
                descending
                :titles="titles"
                :fieldsHiddenMain="['updated_at','service_id']"
                :title='name + " - Prices"'
                force-reload
                :actions-extra-main="actionsExtraMain"
                :conditional-action="conditionalActions"
                :enableEdit="false"
                :enableDelete="false"
                :formatter="formatter"
                :fieldsExtraAdd="fieldsExtraAdd"
                :fieldsHiddenAdd="['updated_at','created_at','id','service_id','deleted_at']"
                :rowCallBack="rowCallBack"
                :add-rules="rules(true)"
                :edit-rules="rules(false)"
        ></DataTable>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    const number = value => {
        const pattern = /^\d+(\.\d+)?$/;
        return pattern.test(value) || "Must be number";
    };
    const required = value => !!value || 'This Field Is Required';
    export default {
        name: "ServicePrices",
        title: 'Prices',
        components: {DataTable},
        data() {
            return {
                id: null,
                name: null,
                rowCallBack: (item) => {
                    if (!item.deleted_at) return ["active-price"];
                    return [];
                },
                extraChargesServiceId: null
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.name = this.$route.query.name || "Unknown";
        },
        methods: {
            rules(add) {
                return {
                    base_fare: add ? [
                        required, number
                    ] : [number],
                    waiting_cost_per_min: add ? [
                        required, number
                    ] : [number],
                    booking_cost_per_min: add ? [
                        required, number
                    ] : [number],
                    booking_distance_per_km: add ? [
                        required, number
                    ] : [number],
                    long_distance_cost_per_km: add ? [
                        required, number
                    ] : [number],
                    booking_fee: add ? [
                        required, number
                    ] : [number],
                    passenger_penalty: add ? [
                        required, number
                    ] : [number]
                }
            },
        },
        computed: {
            formatterExtraCharges() {
                return {
                    to_date(val) {
                        if (!val)
                            return "N\\A";
                        return val
                    },
                    area_id(val, item) {
                        if (!val)
                            return "N\\A";
                        return item.area.title
                    },
                    deleted_at(val) {
                        if (!val)
                            return "N\\A";
                        return val;
                    },
                    apply_area_on(val) {
                        if (!val)
                            return "N\\A";
                        return val;
                    }
                    // to_date(val) {
                    //     if (!val)
                    //         return "N\\A";
                    //     return val
                    // },       to_date(val) {
                    //     if (!val)
                    //         return "N\\A";
                    //     return val
                    // },
                }
            },
            actionsExtraMain() {
                return {
                    extraCharges: {
                        title: "Extra Charges",
                        color: "primary",
                        action: (item) => {
                            this.extraChargesServiceId = item.id
                        }
                    }
                }
            },
            conditionalActions() {
                return {
                    extraCharges: item => item.deleted_at === null
                }
            },
            titles() {
                return {
                    "id": "#",
                    "deleted_at": "Ended At",
                    "created_at": "Started At",
                    'base_fare': "Base Fare",
                    'waiting_cost_per_min': "Waiting Cost/Minute",
                    "booking_cost_per_min": "Booking Cost/Minute",
                    "booking_cost_per_km": "Booking Cost/KM",
                    "long_distance_cost_per_km": "Long Distance Cost / KM",
                    "minimum_charge": "Minimum Charge",
                    "booking_fee": "Booking Fee",
                    "passenger_penalty": "Passenger Penalty"
                }
            },
            formatter() {
                return {
                    deleted_at(value) {
                        if (value == null) return "ACTIVE";
                        else return value;
                    },
                    base_fare(value) {
                        return JSON.stringify(value);
                    },
                    waiting_cost_per_min(value) {
                        return JSON.stringify(value);
                    },
                    booking_cost_per_min(value) {
                        return JSON.stringify(value);
                    },
                    booking_cost_per_km(value) {
                        return JSON.stringify(value);
                    },
                    long_distance_cost_per_km(value) {
                        return JSON.stringify(value);
                    }
                }
            },
            fieldsExtraAdd() {
                return {
                    "base_fare": "v-text-field",
                    "waiting_cost_per_min": "v-text-field",
                    "booking_cost_per_min": "v-text-field",
                    "booking_cost_per_km": "v-text-field",
                    "minimum_charge": "v-text-field",
                    "long_distance_cost_per_km": "v-text-field",
                    "booking_fee": "v-text-field",
                    "passenger_penalty": "v-text-field"
                }
            },
            fieldsExtraAddExtraCharges() {
                return {
                    from_date: "choose-date",
                    to_date: "choose-date",
                    from_time: "choose-time",
                    to_time: "choose-time",
                    amount: "v-text-field",
                    apply_area_on: "v-select",
                    area_id: "choose-locations",
                    type: "v-select"
                }
            },
            titlesExtraCharges() {
                return {
                    id: "#",
                    from_date: "From (Date)",
                    to_date: "To (Date)",
                    from_time: "From (Time)",
                    to_time: "To (Time)",
                    type: "Type",
                    amount: "Amount (SYP Or Percentage)",
                    area_id: "Area",
                    apply_area_on: "Area Constraint",
                    created_at: "Creation Date",
                    deleted_at: "Delete Date"
                }
            },
            rulesExtraCharge() {
                return {
                    from_date: [val => !!val || "This field is required"],
                    from_time: [val => !!val || "This field is required"],
                    to_time: [val => !!val || "This field is required"],
                    amount: [val => !!val || "This field is required"],
                    type: [val => !!val || "This field is required"],

                }
            }
        }
    }
</script>

<style>
    .active-price {
        background: lightgreen;
    }
</style>
